import { Button, UnstyledButton } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import {
	NavigationIntent,
	OrganizationType,
	routingClient
} from '@newo/routing-client';
import { ArrowRightLeft } from 'lucide-react';
import { useHostContext } from '@/context/HostContext.tsx';
import useQueryParams from '@/hooks/useQueryParams.ts';
import { useAgentTraining } from '@/store/agent-training.ts';
import { cn } from '@/utils';

type NavigateToPartnerCtaProps = {
	onBeforeRedirect?: () => void;
	className?: string;
};
const NavigateToPartnerCta = function NavigateToPartnerCta({
	onBeforeRedirect,
	className
}: NavigateToPartnerCtaProps) {
	const { partner_idn } = useAgentTraining();
	const {
		params: { partner_idn: queryPartnerIDn }
	} = useQueryParams();
	const effectivePartnerIDn = queryPartnerIDn || partner_idn;
	const { width: viewportW } = useViewportSize();
	const isMobile = viewportW < 768;
	const { localization } = useHostContext();
	const handleNavigateToPartnerPortal = () => {
		if (!effectivePartnerIDn) {
			return;
		}

		onBeforeRedirect?.();
		routingClient.emitNavigation({
			intent: NavigationIntent.PartnerCustomers,
			params: {
				organizationIdn: effectivePartnerIDn,
				organizationType: OrganizationType.Partner
			}
		});
	};

	if (!effectivePartnerIDn) {
		return;
	}
	return (
		<>
			{isMobile ? (
				<UnstyledButton
					className={cn(className, 'w-7 h-7 flex justify-center items-center')}
					data-testid="navigate-to-partner-portal-cta"
					onClick={handleNavigateToPartnerPortal}
				>
					<ArrowRightLeft />
				</UnstyledButton>
			) : (
				<Button
					className={className}
					data-testid="navigate-to-partner-portal-cta"
					leftSection={<ArrowRightLeft />}
					onClick={handleNavigateToPartnerPortal}
				>
					{localization.translate('creator', 'partner_dashboard_cta')}
				</Button>
			)}
		</>
	);
};

export default NavigateToPartnerCta;
